<template>
<div>
        <div class="columns box">
          <div class="column is-4">
              <label class="label">Limit</label>
              <div class="control">
                <div class="select">
                  <select v-model="LimitSelected" @change="getShots">
                    <option v-for="option in LimitOptions" v-bind:value="option.value" v-bind:key="option.value">{{option.text}}</option>
                  </select>
                </div>
              </div>
              <label class="label">Grid Size</label>
              <div class="control">
                <div class="select">
                  <select v-model="GridSize" @change="getShots">
                    <option v-for="option in GridOptions" v-bind:value="option.value" v-bind:key="option.value">{{option.text}}</option>
                  </select>
                </div>
              </div>
          </div>
          <div class="column is-4">
              <label class="label">Shot Type</label>
              <div class="control">
                <div class="select">
                  <select v-model="ShotSelected" @change="getShots">
                    <option v-for="option in ShotOptions" v-bind:value="option.value" v-bind:key="option.value">{{option.text}}</option>
                  </select>
                </div>
              </div>
              <label class="label">Team</label>
              <div class="control">
                <div class="select">
                  <select v-model="TeamSelected" @change="getShots">
                    <option v-for="option in TeamOptions" v-bind:value="option.value" v-bind:key="option.value">{{option.text}}</option>
                  </select>
                </div>
              </div>
              <div class="control">
                <button class="button is-info" v-on:click="showGrid = !showGrid; UseHeatmap=false; getShots()">Show Grid</button>
              </div>
          </div>
          <div class="column is-2">
            <h1>Goals: {{actualGoals}}</h1>
            <h1>Sum XG: {{expectedGoals.toFixed(2)}}</h1>
            <div class="control">
              <button class="button is-primary is-small" @click="UseHeatmap = !UseHeatmap; beginRender()">Heatmap</button>
            </div>
            <div v-if="UseHeatmap">
              <label class="label">Blur</label>
              <div class="control">
                <input class="input is-small" type="number" step="any" placeholder="0.5" v-model="BlurSelected" @change="beginRender">
              </div>
            </div>
            <div v-if="UseHeatmap">
              <label class="label" >Radius</label>
              <div class="control">
                <input class="input is-small" type="number" step="any" placeholder="0.5" v-model="RadiusSelected" @change="beginRender">
              </div>
            </div>
          </div>
        </div>
        <div class="stats-widget" id="widget-shot-map">
            <div class="stats-widget-canvas-container">
                <img class="stats-widget-canvas-container-bg" src="data:image/svg+xml;base64,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" alt="" id="stats-widget-canvas-bg">
                <canvas ref="shot_canvas" class="stats-widget-canvas" id="stats-widget-canvas-shot"></canvas>
                <div class="stats-widget-tooltip" id="tooltip"></div>
            </div>
        </div>
    </div>
</template>

<script>
import simpleshot from '../../../store/modules/simpleheat/simpleshot_eihl'
import simpleheat from '../../../store/modules/simpleheat/simpleheat'
export default {
  data () {
    return {
      Shots: [],
      XGShots: [],
      shotData: [],
      Squares: [],
      LimitSelected: 999999,
      GridSize: 11,
      GridOptions: [
        {'text': '1x1 - 2', 'value': 1},
        {'text': '2x2 - 4', 'value': 2},
        {'text': '4x4 - 8', 'value': 4},
        {'text': '5x5 - 25', 'value': 5},
        {'text': '6x6 - 36', 'value': 6},
        {'text': '8x8 - 64', 'value': 8},
        {'text': '9x9 - 81', 'value': 9},
        {'text': '10x10 - 100', 'value': 10},
        {'text': '11x11 - 121', 'value': 11},
        {'text': '12x12 - 144', 'value': 12},
        {'text': '13x13 - 169', 'value': 13},
        {'text': '14x14 - 196', 'value': 14},
        {'text': '20x20 - 400', 'value': 20}
      ],
      TeamSelected: 0,
      TeamOptions: [
        {'text': 'All', 'value': 0},
        {'text': 'Cardiff Devils', 'value': 92},
        {'text': 'Belfast Giants', 'value': 91},
        {'text': 'Coventry Blaze', 'value': 93},
        {'text': 'Dundee Stars', 'value': 94},
        {'text': 'Fife Flyers', 'value': 95},
        {'text': 'Glasgow Clan', 'value': 96},
        {'text': 'Guildford Flames', 'value': 97},
        {'text': 'Manchester Storm', 'value': 98},
        {'text': 'Nottingham Panthers', 'value': 99},
        {'text': 'Sheffield Steelers', 'value': 100}
      ],
      LimitOptions: [
        {'text': 0, 'value': 0},
        {'text': 5, 'value': 5},
        {'text': 10, 'value': 10},
        {'text': 15, 'value': 15},
        {'text': 20, 'value': 20},
        {'text': 200, 'value': 200},
        {'text': 'All', 'value': 999999}
      ],
      PlayerSelected: 0,
      PlayerOptions: [],
      ShotSelected: 4,
      ShotOptions: [
        {'text': 'Blocked', 'value': 3},
        {'text': 'Wide', 'value': 2},
        {'text': 'OnNet', 'value': 1},
        {'text': 'Goal', 'value': 4},
        {'text': 'OnNet & Goal', 'value': 5},
        {'text': 'Excluding Goals', 'value': 6},
        {'text': 'All', 'value': 0}
      ],
      showGrid: true,
      expectedGoals: 0,
      actualGoals: 0,
      RadiusSelected: 15,
      BlurSelected: 40,
      UseHeatmap: false,
      IntShotData: [],
      deShots: [],
      gridJSON: []
    }
  },
  components: {
    'simpleshot': simpleshot,
    'simpleheat': simpleheat
  },
  methods: {
    fetchShotmap () {
      let postData = {
        'id': 1,
        'period': 0,
        'situation': 0,
        'home_player': 0,
        'away_player': 0,
        'shot_type': 0
      }
      console.log('Filter: ' + JSON.stringify(postData))
      this.$http
        .post('https://devilsapi.roblutken.com/api/app/get/match-stats/shotmap/', postData, {
          headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=', 'Content-Type': 'application/json' }
        })
        .then(
          response => {
            console.log(response.data)
            this.IntShotData = response.data.home_shots
            this.formatInterShotData()
          },
          response => { }
        )
    },
    getShots: function () {
      let postData = {
        'limit': this.LimitSelected,
        'shot_type': this.ShotSelected,
        'team_selected': this.TeamSelected
      }
      this.$http
        .post('https://devilsapi.roblutken.com/api/eihl/shots/get', postData, {
          headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=', 'Content-Type': 'application/json' }
        })
        .then(
          response => {
            this.Shots = response.data
            console.log(this.Shots)
          },
          response => {}
        )
      postData = {
        'limit': 9999999,
        'shot_type': 5,
        'team_selected': 0
      }
      this.$http
        .post('https://devilsapi.roblutken.com/api/eihl/shots/get', postData, {
          headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=', 'Content-Type': 'application/json' }
        })
        .then(
          response => {
            this.XGShots = response.data
            this.fomratXGData()
            this.formatShotData()
            this.beginRender()
          },
          response => {}
        )
    },
    convertLeft (a, b) {
      var c = (b + 100) / 2
      return a <= 0 ? c : 100 - c
    },
    convertTop (xPos) {
      return xPos <= 0 ? xPos + 100 : 100 - xPos
    },
    fomratXGData: function () {
      var container = document.getElementById('stats-widget-canvas-bg')
      var x = parseInt(container.width)
      var y = parseInt(container.height)
      for (var xg of this.XGShots) {
        let shot = []
        shot[0] = x * this.convertTop(xg.location_x) / 100
        shot[1] = y * this.convertLeft(xg.location_x, xg.location_y) / 100
        xg.location_x = shot[0]
        xg.location_y = shot[1]

        if (xg.shot_type === 1) {
          xg.color = 'rgb(180, 8, 8)'
        } else if (xg.shot_type === 2) {
          xg.color = 'rgba(95, 93, 93)'
        } else if (xg.shot_type === 3) {
          xg.color = 'rgba(20, 23, 81)'
        } else {
          xg.color = 'rgb(31, 239, 0)'
        }
        // console.log(xg.location_y)
      }
    },
    formatInterShotData: function () {
      var container = document.getElementById('stats-widget-canvas-bg')
      var x = parseInt(container.width, 10)
      var y = parseInt(container.height, 10)
      var width = x / 600.0
      var height = y / 530.0
      console.log('w: ' + width + ' h: ' + height)
      // var homeShotsCanvas = this.$refs.shot_canvas
      let shots = []
      for (var s of this.IntShotData) {
        let shot = JSON.parse(s.shot_location)
        let loc = JSON.parse(s.shot_location)
        shot[5] = shot[0]
        shot[6] = shot[1]

        shot[0] = parseInt(loc[1], 10)
        shot[1] = parseInt(loc[0], 10)

        shot[2] = 40
        if (this.UseHeatmap === false) {
          if (s.shot_type === 'OnNet') {
            shot[4] = 'rgb(180, 8, 8)'
            shot[3] = 5
          } else if (s.shot_type === 'MissedNet') {
            shot[4] = 'rgba(95, 93, 93)'
            shot[3] = 3
          } else if (s.shot_type === 'Blocked') {
            shot[4] = 'rgba(20, 23, 81)'
            shot[3] = 3
          } else if (s.shot_type === 'Goal') {
            shot[4] = 'rgb(31, 239, 0)'
            shot[3] = 6
          } else {
            shot[4] = 'White'
          }
        }
        if (s.shot_type === 'Goal') {
          console.log('CW: ' + width + ' CH: ' + height + 'Width: ' + x + ' Height: ' + y + ' X: ' + shot[0] + ' Y: ' + shot[1] + ' Origin x' + shot[5] + ' y ' + shot[6])
          shots.push(shot)
          this.deShots.push(shot)
        }
        // console.log('Shot found: ' + shot)
      }
      // console.log('Rendering shots: ' + container.width + ' H: ' + container.height + JSON.stringify(shots))
      // var shotmap = simpleshot(homeShotsCanvas, parseInt(container.width, 10), parseInt(container.height, 10)).data(shots)
      // shotmap.render()
    },
    formatShotData: function () {
      var container = document.getElementById('stats-widget-canvas-bg')
      var x = parseInt(container.width)
      var y = parseInt(container.height)
      this.shotData = []
      if (this.UseHeatmap === true) {
        for (var h of this.Shots) {
          let shot = []
          shot[1] = x * this.convertTop(h.location_x) / 100
          shot[0] = y * this.convertLeft(h.location_x, h.location_y) / 100
          shot[2] = 40
          this.shotData.push(shot)
          // console.log(this.shotData)
        }
      } else {
        for (var s of this.Shots) {
          let shot = []
          shot[0] = x * this.convertTop(s.location_x) / 100
          shot[1] = y * this.convertLeft(s.location_x, s.location_y) / 100
          shot[5] = s.shot_type
          // console.log(s.shot_type)
          if (s.shot_type === 2) {
            shot[4] = 'rgba(95, 93, 93)'
            shot[3] = Math.ceil(2 + x / 200 * 1)
          } else if (s.shot_type === 3) {
            shot[4] = 'rgba(20, 23, 81)'
            shot[3] = Math.ceil(2 + x / 200 * 1)
          } else if (s.shot_type === 1) {
            shot[4] = 'rgb(180, 8, 8)'
            shot[3] = Math.ceil(2 + x / 200 * 1)
          } else if (s.shot_type === 4) {
            shot[4] = 'rgb(31, 239, 0)'
            shot[3] = Math.ceil(2 + x / 200 * 1)
          } else {
            shot[4] = 'rgb(0, 0, 0)'
            shot[3] = Math.ceil(2 + x / 200 * 1)
          }
          this.shotData.push(shot)
        }
      }
      return this.shotData
    },
    renderGrid: function () {
      var container = document.getElementById('stats-widget-canvas-bg')
      var homeShotsCanvas = this.$refs.shot_canvas
      var ctx = homeShotsCanvas.getContext('2d')
      var rectWidth = container.width
      var rectHeight = container.height
      var scaleFactor = this.GridSize
      this.expectedGoals = 0
      let json = []
      for (var y = 0; y < rectHeight; y += rectHeight / scaleFactor) {
        for (var x = 0; x < rectWidth; x += rectWidth / scaleFactor) {
          var xPos = [x, y, rectWidth / scaleFactor, rectHeight / scaleFactor]
          var lastXMax = x + (rectWidth / scaleFactor)
          var lastYMax = y + (rectHeight / scaleFactor)
          if (this.showGrid === true) {
            json.push(this.drawGridSquare(ctx, xPos, lastXMax, lastYMax))
          }
        }
      }
      console.log('JSON: ' + JSON.stringify(json))
    },
    drawGridSquare (ctx, pos, xMax, yMax) {
      var xG = this.calculateXG(pos[0], pos[1], xMax, yMax, ctx)
      var shots = this.calculateShots(pos[0], pos[1], xMax, yMax, ctx)
      this.expectedGoals += parseFloat(shots)
      let json = {xMin: parseFloat(pos[0]), xMax: parseFloat(xMax), yMin: parseFloat(pos[1]), yMax: parseFloat(yMax), XG: parseFloat(xG)}
      let color = 'rgba(255,0,0,0.1)'
      if (xG > 0.0) {
        let r = (shots >= 1.0 ? 255 : (shots <= 0.0 ? 0 : Math.floor(shots * 256.0)))
        color = 'rgba(' + r * 10 + ', 0,0,.4)'
      }
      this.drawRect(ctx, color, pos)
      this.drawText(ctx, 'white', 'XG' + xG + '-' + shots, [pos[0] + 5, pos[1] + 20])
      return json
    },
    calculateXG: function (xMin, yMin, xMax, yMax, ctx) {
      var shotCount = 0
      var goalsCount = 0
      for (var shot of this.XGShots) {
        if (shot.location_y >= xMin && shot.location_y <= xMax && shot.location_x >= yMin && shot.location_x <= yMax) {
          shotCount++
          if (shot.shot_type === 4) {
            goalsCount++
          }
        //  this.drawCircle(ctx, shot.location_x, shot.location_y, shot.color, 2)
        }
      }
      if (goalsCount > 0 && shotCount > 0) {
        var xG = (goalsCount / shotCount).toFixed(2)
        return xG
      }
      return 0
    },
    calculateShots: function (xMin, yMin, xMax, yMax, ctx) {
      var xG = this.calculateXG(xMin, yMin, xMax, yMax, ctx)
      if (xG > 0) {
        var selectShots = 0
        for (var ss of this.deShots) {
          // this.drawCircle(ctx, ss[0], ss[1], ss[4], 2)
          if (ss[1] >= xMin && ss[1] <= xMax && ss[0] >= yMin && ss[0] <= yMax) {
            selectShots++
          }
        }
        return (xG * selectShots).toFixed(2)
      }
      return 0
    },
    drawCircle (ctx, posX, posY, color = 'rgb(0,255,0)', radius = 1) {
      ctx.shadowOffsetX = ctx.shadowOffsetY = 0.8
      ctx.shadowBlur = 4
      ctx.shadowColor = 'rgb(0, 0, 0)'
      ctx.fillStyle = color
      ctx.beginPath()
      ctx.arc(posY, posX, radius, 0, Math.PI * 2, true)
      ctx.closePath()
      ctx.fill()
    },
    drawRect (ctx, color, position) {
      ctx.beginPath()
      ctx.fillStyle = color
      ctx.strokeStyle = '#FFFFFF'
      ctx.shadowOffsetX = ctx.shadowOffsetY = 0.0
      ctx.shadowBlur = 0.2
      ctx.shadowColor = 'rgb(1, 1, 1)'
      ctx.fillRect(position[0], position[1], position[2], position[3])
      ctx.strokeRect(position[0], position[1], position[2], position[3])
      ctx.closePath()
    },
    drawText (ctx, colour, text, textPosition, textSize = '16px', lineWidth = 3) {
      ctx.beginPath()
      ctx.font = textSize + ' sans-serif'
      ctx.fillStyle = colour
      ctx.fillText(text, textPosition[0], textPosition[1])
      ctx.closePath()
    },
    canvasResize: function (event) {
      console.log('Resize:' + event)
      this.beginRender()
    },
    beginRender: function () {
      var homeShotsCanvas = this.$refs.shot_canvas
      var container = document.getElementById('stats-widget-canvas-bg')

      if (this.UseHeatmap === true) {
        // console.log('Use home heatmap' + this.formatShotData())
        var homeHeatmap = simpleheat(homeShotsCanvas).data(this.formatShotData())
        homeHeatmap.radius(this.RadiusSelected, this.BlurSelected)
        homeHeatmap.draw()
      } else {
        var shotmap = simpleshot(homeShotsCanvas, parseInt(container.width, 10), parseInt(container.height, 10)).data(this.formatShotData())
        shotmap.render()
        this.renderGrid()
      }
    }
  },
  created () {
    this.getShots()
    this.$nextTick(function () {
      window.addEventListener('resize', this.canvasResize)
      window.addEventListener('resize', this.canvasResize)
    })
  }
}
</script>
<style scoped>
    /*** uncss> filename: build/style/shot-map.css ***/
    img {
        border: 0
    }

    html {
        font-family: sans-serif;
        -ms-text-size-adjust: 100%;
        -webkit-text-size-adjust: 100%
    }

    body {
        margin: 0
    }

    canvas {
        display: inline-block;
        vertical-align: baseline
    }


    #stats-widget-filter-container:after {
        clear: both
    }

    body,html {
        background-color: transparent!important;
        font-family: 'Noto Sans',arial,helvetica,sans-serif!important;
        font-size: 12px;
        line-height: 1;
        color: #001626
    }


    .stats-widget {
        width: 100%;
        position: relative;
        font-size: 16px;
        font-size: 1rem;
        padding: 0
    }



    .stats-widget-select-container {
        margin-top: 5px;
        border: 1px solid #111;
        box-sizing: border-box;
        width: 100%;
        display: block;
        background: #fff
    }

    .stats-widget-select-container select {
        outline: 0!important;
        background: 0 0;
        border: none;
        color: #111;
        font-size: 14px;
        height: 29px;
        padding: 5px;
        width: 100%
    }

    .stats-widget-alert,.stats-widget-info {
        text-transform: uppercase;
        font-size: 1.4em;
        text-align: center
    }

    .stats-widget-loader {
        background: #fff;
        color: #c8102e;
        position: absolute;
        z-index: 1000;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0
    }

    .stats-widget-info {
        font-weight: 700;
        margin-top: 40%;
        display: block;
        color: #c8102e
    }

    .stats-widget-alert {
        padding: 0 5%;
        display: none;
        font-weight: 400;
        margin-top: 50%;
        line-height: 1.4;
        color: #001626
    }

    .stats-widget-canvas-container {
        position: relative;
        width: 600px;
        overflow: hidden
    }

    .stats-widget-canvas-container-bg {
        width: 600px;
        height:  530px;
        display: block
    }

    .stats-widget-canvas {
        position: absolute;
        top: 0;
        left: 0
    }

    .stats-widget-tooltip {
        position: absolute;
        display: none;
        top: -500px;
        left: -500px;
        width: 200px;
        height: 30px;
        text-align: center;
        box-sizing: border-box;
        line-height: 18px;
        font-size: 14px;
        padding: 6px 8px;
        background: #dcdcdc;
        color: #000;
        border-radius: 4px
    }
</style>



// WEBPACK FOOTER //
// eihl_shotmap.vue?5aea6b79